<section class="confirm-page">
  @if (state === 'working') {
    <p class="working">{{ 'common.loading' | t }}</p>
  } @else if (state === 'confirmed') {
    <div class="confirm-card">
      <mat-icon class="status-icon ok">check_circle</mat-icon>
      <h2>{{ 'account.confirmedTitle' | t }}</h2>
      <p>{{ 'account.confirmed' | t }}</p>
      <a mat-flat-button color="primary" [routerLink]="['/signin']">
        <mat-icon>login</mat-icon>
        {{ 'account.goSignIn' | t }}
      </a>
    </div>
  } @else {
    <div class="confirm-card">
      <mat-icon class="status-icon warn">error_outline</mat-icon>
      <h2>{{ 'account.confirmFailedTitle' | t }}</h2>
      <p>{{ 'account.confirmFailedText' | t }}</p>
      <a mat-stroked-button color="primary" [routerLink]="['/signin']">
        <mat-icon>login</mat-icon>
        {{ 'account.goSignIn' | t }}
      </a>
    </div>
  }
</section>
